import React from "react";
import { Box, Tabs, Tab } from "app/material-framework/materialComponents";

export function ChatbotTabs({ tab, setTab, tabLabels }) {
  return (
    <Box sx={{ borderBottom: 1, borderColor: "#D9D9D9", bgcolor: "#F5F5F5" }}>
      <Tabs value={tab} onChange={(_, v) => setTab(v)} indicatorColor="primary" textColor="primary" variant="fullWidth">
        {tabLabels.map((label, idx) => (
          <Tab key={label} label={label} />
        ))}
      </Tabs>
    </Box>
  );
}
